import type {
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  PublisherProvider,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { isTextSelection, TOOLBARS } from './../../../editor-common';

import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { RicosToolbar } from '../ricos-toolbar';
import { formattingItemsRenderers } from './formatting-renderers';

export class FormattingToolbar extends RicosToolbar<TOOLBARS.INLINE> {
  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<TOOLBARS.INLINE>,
    shouldCreate: boolean
  ) {
    super(isMobile, services, TOOLBARS.INLINE, publishers, settings);
    this.isEmpty = () => !shouldCreate;
  }

  isVisible = (): boolean => {
    const editor = this.services.editor;
    const { selection, doc } = editor.adapter.tiptapEditor.state;

    if (selection.empty) {
      return false;
    }

    let hasNonEmptyParagraph = false;
    doc.nodesBetween(selection.from, selection.to, node => {
      if (node.type.name === 'text' && node.text !== '') {
        hasNonEmptyParagraph = true;
        return false;
      }
    });

    return hasNonEmptyParagraph && isTextSelection(selection);
  };

  getToolbarItemsConfig(options?: { disabled: boolean }): IToolbarItemConfigTiptap[] {
    return this.services.plugins
      .getTextButtons()
      .toToolbarItemsConfig(
        TOOLBARS.INLINE,
        this.isMobile,
        this.services.editor.getPublicCommands(),
        this.services.editor.adapter.tiptapEditor,
        options
      );
  }

  getMegaToolbarItemsConfig(options?: { disabled: boolean }): IToolbarItemConfigTiptap[] {
    return this.getToolbarItemsConfig(options);
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    return formattingItemsRenderers;
  }
}
